import React, { useEffect, useState } from 'react'
import Banner from './Banner';
import { ReactComponent as InfoIcon } from '../../assets/plus_icon/incentive_pending.svg';
import { ReactComponent as ScanIcon } from '../../assets/plus_icon/scan.svg';
import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import BrokerCodeModal from './Modal/BrokerCodeModal';
import GetBrokerCodeModal from './Modal/GetBrokerCodeModal';
import BorkerQRCode from './Modal/BorkerQRCode';
import PhoneInput from 'react-phone-input-2';
import InputSelect from '../../components/InputGroup/InputSelect';
import Select from 'react-select';
import { ReactComponent as RightIcon } from '../../assets/righticon.svg'
import { checkBrokerInCompany, getBrokerCompanies } from '../../services/private/site-visit.service';
import AsyncSelect from 'react-select/async';
// import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import 'react-phone-input-2/lib/style.css'

const customStyles = {
    control: (base, state) => ({
        ...base,
        boxShadow: "none",
        borderColor: '#ced4da',
        // backgroundColor: '#FAFAFB',
        minHeight: '58px',
        minWidth: '100%',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: '400',
        cursor: 'pointer',
        '&:focus': { borderColor: '#0062ff' },
    }),
    option: (styles, state) => ({
        ...styles,
        fontSize: '14px',
        cursor: 'pointer',
        backgroundColor: state.isSelected ? "#f1f1f5" : styles.color,
        color: '#44444f',
        zIndex: 99,
        "&:hover": {
            color: "#44444f",
            backgroundColor: "#f1f1f5"
        },
    }),
};
const mobileCustomStyles = {
    control: (base, state) => ({
        ...base,
        boxShadow: "none",
        borderColor: '#ced4da',
        // backgroundColor: '#FAFAFB',
        minHeight: '38px',
        minWidth: '100%',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: '400',
        cursor: 'pointer',
        '&:focus': { borderColor: '#0062ff' },
    }),
    option: (styles, state) => ({
        ...styles,
        fontSize: '14px',
        cursor: 'pointer',
        backgroundColor: state.isSelected ? "#f1f1f5" : styles.color,
        color: '#44444f',
        zIndex: 99,
        "&:hover": {
            color: "#44444f",
            backgroundColor: "#f1f1f5"
        },
    }),
};


const BorkerDetailForm = ({ setChannelPartner, isWithCP, brokerCode, setBrokerCode, brokerName, brokerMobile, companyId, setBrokerName, setBrokerMobile, setCompanyId }) => {

    const [showBrokerCodeModal, setShowBrokerCodeModal] = useState(false);
    const [showQRCodeModal, setShowQRCodeModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [name, setName] = useState('')
    const [mobile, setMobile] = useState('')
    const [companyName, setCompanyName] = useState('');
    const [companyList, setCompanyList] = useState([])
    const [error, setError] = useState(false);
    const [userNotFount, setUserNotFound] = useState(false);
    const [mobileError, setMobileError] = useState(false);

    const getCompany = async (company) => {
        const res = await getBrokerCompanies(company);
        if (res.data.status === 200) {
            const list = res.data.data
                .filter(i => i.company_name)
                .map(i => (
                    {
                        label: <div className='w-full flex justify-between text-sm sm:text-base'> <span>{i.company_name}</span> <span>{i.owner_name} ({i.owner_mobile})</span> </div>,
                        value: i.id
                    }
                ))
            return list;
            // setCompanyList(list)
        }
    }

    // useEffect(() => {
    //     getCompany();
    // }, [])
    const handleSubmit = async () => {
        if (!brokerName || !brokerMobile || !companyId) {
            setError(true);
            return
        } else {
            setError(false);
        }
        if (brokerMobile.length < 12) {
            setMobileError(true);
            return;
        } else {
            setMobileError(false)
        }
        const payload = {

            broker_mobile: brokerMobile,
            broker_company_id: companyId.value
        }
        try {
            const res = await checkBrokerInCompany(payload);
            if (res.data.status === 200) {
                console.log(res.data.data, 'check');

                setChannelPartner('5')
            }
        } catch (err) {
            if (err.response.data.status === 404) {
                setUserNotFound(true);
            }
        }

        // if (isWithCP) {
        //     setChannelPartner('5')
        // } else {
        //     setChannelPartner('7')
        // }
    }

    return (
        <div className=' mx-auto overflow-auto h-100'>
            <div className='!w-full broker-info'>
                <Banner />
            </div>
            <div className='flex items-center justify-center !my-3 sm:!my-6 !p-4 md:!p-12 bg-white rounded-xl relative'>
                {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
                <button className='flex items-center static sm:absolute sm:left-4 md:left-12' onClick={() => setChannelPartner('3')}>
                    <LeftArrowIcon className='stroke-black800 rotate-180 mr-1' /> <span className='hidden sm:inline-block'>Back</span>
                </button>
                <p className='flex flex-col mb-0 ml-2 sm:ml-0'>
                    <span className='text-lg sm:text-xl font-medium'>Fill Channel Partner Details - <span className='text-[#2064FA]'>Coral Park</span> </span>
                    {/* <span className='text-xl !mt-4'>Powered By Propacity</span> */}
                </p>
                {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
            </div>
            <div className='bg-white  overflow-y-scroll md:overflow-hidden rounded-xl !p-4 md:!p-12 space-y-4 md:space-y-10'>
                <div className='w-full flex flex-col sm:space-x-6'>
                    <div className={`flex-col font-medium relative w-full hidden sm:flex`}>
                        <label className='sm:!text-lg text-base !mb-3 '>CP Company<sup className='text-red'>*</sup></label>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={getCompany}
                            defaultOptions
                            placeholder='Search and Select Company'
                            styles={customStyles}
                            value={companyId}
                            onChange={(e) => {
                                setCompanyId(e)
                            }}
                            isClearable={true}
                            menuPosition={'fixed'}
                        />
                    </div>
                    <div className={` flex flex-col font-medium w-full sm:hidden`}>
                        <label className='sm:!text-lg text-base !mb-3 '>CP Company<sup className='text-red'>*</sup></label>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={getCompany}
                            defaultOptions
                            placeholder='Search and Select Company'
                            styles={mobileCustomStyles}
                            value={companyId}
                            onChange={(e) => {
                                setCompanyId(e)
                            }}
                            isClearable={true}
                            menuPosition={'fixed'}
                        />
                    </div>
                    {error && !companyId?.value && (
                        <div className="text-red sm:!text-sm text-xs font-medium !mt-4 !ml-0">Please Select Company.</div>
                    )}
                </div>
                <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                    <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>CP Name<sup className='text-red'>*</sup></label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            name='name'
                            value={brokerName}
                            onChange={(e) => setBrokerName(e.target.value)}
                            placeholder={'Enter CP Name'}
                        />
                        {error && !brokerName && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter CP Name</div>

                        )}
                    </div>
                    <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>CP Mobile <sup className='text-red'>*</sup></label>
                        <PhoneInput
                            inputClass={'border !w-full focus:outline-none focus:border-primary rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                            // containerClass={classname}
                            country={'in'}
                            value={brokerMobile}
                            countryCodeEditable={false}
                            enableSearch={true}
                            disableSearchIcon={true}
                            // dropdownClass={'!fixed '}
                            onChange={phone => {
                                setBrokerMobile(phone)
                            }}
                        />
                        {error && !brokerMobile && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter CP Mobile No.</div>
                        )}
                        {
                            mobileError && brokerMobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>
                        }
                    </div>
                </div>

                {userNotFount && <p className="text-red sm:!text-lg text-base !mt-4"> Your account doesn’t exist in this company. Please contact Propacity Support</p>}
                <div
                    className='rounded-xl border  !h-[42px] sm:!h-[54px] flex justify-between cursor-pointer items-center sm:!px-6 !px-3'
                    onClick={() => {
                        setBrokerName('');
                        setBrokerMobile('');
                        setCompanyId('');
                        setChannelPartner('8')
                    }}
                >
                    <span className='text-sm sm:!text-base text-blue-900 font-semibold leading-9'>Couldn’t Find Your Company?</span>
                    <span >
                        <RightIcon className='stroke-blue-900 ' />
                    </span>
                </div>
                <div className='w-full sm:space-x-4 space-y-4 space-y-reverse sm:space-y-0 flex flex-col-reverse sm:flex-row' >
                    <button className='w-full sm:w-1/2 text-base sm:!text-lg border rounded-xl !py-2  sm:!py-3.5' onClick={() => setChannelPartner('3')}>Back</button>
                    <button className='w-full sm:w-1/2 text-base sm:!text-lg rounded-xl !py-2  sm:!py-3.5 bg-blue-900 text-white' onClick={() => {
                        handleSubmit()
                    }}>Next</button>
                </div>
            </div>
            {/* {showQRCodeModal && <BorkerQRCode show={showQRCodeModal} setShowQRCodeModal={setShowQRCodeModal} setShowDetailModal={setShowDetailModal} closeModal={() => setShowQRCodeModal(false)} />}
            {showDetailModal && <GetBrokerCodeModal
                show={showDetailModal}
                setShowBrokerCodeModal={setShowBrokerCodeModal}
                closeModal={() => setShowDetailModal(false)}
            />}
            {showBrokerCodeModal && <BrokerCodeModal show={showBrokerCodeModal} closeModal={() => setShowBrokerCodeModal(false)} setChannelPartner={setChannelPartner} brokerCode={brokerCode} />} */}
        </div >
    )
}

export default BorkerDetailForm